/**
 * Chamadas de voz — o que a tela precisa pedir ao servidor.
 */
import api from "./api";

export interface VoiceCall {
  id: string;
  status: string;
  direction: string;
  fromNumber?: string | null;
  toNumber?: string | null;
  livekitRoom?: string | null;
  answeredByUserId?: string | null;
  initiatedAt?: string | null;
  connectedAt?: string | null;
  endedAt?: string | null;
  durationSeconds?: number | null;
}

export interface VoiceToken {
  token: string;
  url: string;
  room: string;
  expiresInSeconds: number;
}

export interface CallPermission {
  status: "none" | "requested" | "granted" | "denied" | "revoked" | "expired";
  /** Quando o pedido foi enviado — a tela diz há quanto tempo está parado. */
  requestedAt?: string | null;
  expiresAt?: string | null;
  consecutiveUnanswered: number;
  canCall: boolean;
  /** Por que não pode. Vem pronto para a tela — nunca técnico. */
  reason?: string | null;
  callsToday: number;
  maxPerDay: number;
}

export const voiceService = {
  list: (limit = 30) => api.get<VoiceCall[]>("/v1/voice/calls", { limit }),
  get: (id: string) => api.get<VoiceCall>(`/v1/voice/calls/${id}`),

  /** Assume a chamada. Quem chega primeiro leva; os outros recebem 409. */
  accept: (id: string) => api.post<VoiceCall>(`/v1/voice/calls/${id}/accept`),

  /** O bilhete de entrada na sala — vale pouco tempo e só para ela. */
  token: (id: string) => api.post<VoiceToken>(`/v1/voice/calls/${id}/token`),

  decline: (id: string) => api.post<void>(`/v1/voice/calls/${id}/decline`),
  hangup: (id: string) => api.post<VoiceCall>(`/v1/voice/calls/${id}/hangup`),

  /**
   * Dá para ligar para este contato, e se não, por quê.
   *
   * A tela consulta ANTES de mostrar o botão. Um botão que só falha ao ser
   * clicado ensina o atendente a não confiar na ferramenta.
   */
  permission: (contactId: string) =>
    api.get<CallPermission>(`/v1/voice/permissions/${contactId}`),

  /** Pede ao contato autorização para ligar. A Meta exige isso antes. */
  requestPermission: (contactId: string) =>
    api.post<CallPermission>("/v1/voice/permissions/request", { contactId }),

  /** Liga para o contato. O pré-voo roda no servidor e falha fechado. */
  dial: (contactId: string) =>
    api.post<VoiceCall>("/v1/voice/calls", { contactId }),
};

export default voiceService;
